import { Checkbox } from '@material-ui/core'
import { useState, ChangeEvent, useRef } from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import {
    deleteAttachment,
    updateAttachment,
    updateFileName,
    updateIncludeInEmail,
    uploadAttachment,
} from '../../features/order/orderSlice'
import styles from './AttachmentModal.module.scss'
import {
    FastQuoteInput,
    StyledRadio,
    AWCButton,
    BUTTON_TYPES,
} from '../../GlobalComponents/Inputs/Inputs'
import { getAttachmentDownloadURL } from '../../features/order/orderAPI'
import { Scrollbars } from 'react-custom-scrollbars-2'

import { Backdrop, makeStyles, Modal } from '@material-ui/core'
import { fqAlert } from '../../GlobalComponents/NotificationManager/NotificationManager'
import { EditPencil } from '../../GlobalComponents/_icons/Icons'
import { SvgIcon } from '@progress/kendo-react-common'

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 0,
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        // border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}))

interface FQAttachmentModalProps {
    open: boolean
    reviewingQuoteOutput?: boolean
    close(): void
}
export const FastQuoteAttachmentModal = (props: FQAttachmentModalProps) => {
    const { open, reviewingQuoteOutput, close } = props
    const orderFilenames = useAppSelector((state) => state.order.orderFilenames)
    const dispatch = useAppDispatch()

    const addAttachment = (fileName: string, contentType: string, dataURL: string) => {
        dispatch(uploadAttachment({ fileName, contentType, fileData: dataURL }))
    }
    const removeAttachment = (fileId: number) => {
        dispatch(deleteAttachment(fileId))
    }
    const updateAttachmentInternal = (fileId: number, internal: boolean) => {
        dispatch(updateAttachment({ fileId, internal }))
    }

    const classes = useStyles()
    return (
        <Modal
            open={open}
            className={classes.modal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            BackdropComponent={Backdrop}
        >
            {/* <div className={styles.modalContainer}><ShippingModal /></div> */}
            <div>
                <AttachmentModal
                    attachments={orderFilenames}
                    close={close}
                    uploadAttachment={addAttachment}
                    onDelete={removeAttachment}
                    updateIsInternal={updateAttachmentInternal}
                    reviewingQuoteOutput={!!reviewingQuoteOutput}
                />
            </div>
        </Modal>
    )
}
interface AttachmentModalProps {
    close(): void
    attachments: OrderFilenames
    uploadAttachment(fileName: string, contentType: string, dataURL: string): void
    updateIsInternal(fileId: number, internal: boolean): void
    onDelete(fileId: number): void
    reviewingQuoteOutput: boolean
}
export const AttachmentModal = (props: AttachmentModalProps) => {
    const {
        close,
        attachments,
        uploadAttachment,
        onDelete,
        updateIsInternal,
        reviewingQuoteOutput,
    } = props
    const onDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.stopPropagation()
        e.preventDefault()
        let fileArray = Array.from(e.dataTransfer.files)
        // do this in a loop
        // the loadEvent doesn't have info about which file loaded so we have a unique fileReader
        // for each file we need to load
        let eString = ''
        fileArray.forEach((file) => {
            //20mb
            if (file.size > 20971520) {
                eString += `${file.name} is too large. Max file size is 20mb\n`
                return
            }
            let reader = new FileReader()
            reader.addEventListener(
                'load',
                function () {
                    let uri = reader.result
                    uploadAttachment(file.name, file.type, uri as string)
                },
                false
            )

            reader.readAsDataURL(file)
        })
        eString && fqAlert({ type: 'error', title: eString })
    }
    const [tempName, setTempName] = useState('')
    const [editingRowId, setEditingRowId] = useState<number | false>(false)
    const dispatch = useAppDispatch()
    const inputFile = useRef<any>(null)
    const onAttachmentClick = () => {
        inputFile.current.click()
    }
    const onChangeFile = (e: ChangeEvent<HTMLInputElement>) => {
        let fileArray: Array<File> = Array.from(e.target.files!)
        // do this in a loop
        // the loadEvent doesn't have info about which file loaded so we have a unique fileReader
        // for each file we need to load
        let eString = ''
        fileArray.forEach((file) => {
            //20mb
            if (file.size > 20971520) {
                eString += `${file.name} is too large. Max file size is 20mb\n`
                return
            }
            let reader = new FileReader()
            reader.addEventListener(
                'load',
                function () {
                    let uri = reader.result
                    uploadAttachment(file.name, file.type, uri as string)
                },
                false
            )

            reader.readAsDataURL(file)
        })
        eString && fqAlert({ type: 'error', title: eString })
    }

    if (reviewingQuoteOutput) {
        return (
            <div className={styles.attachmentsModal} data-testid="attachmentsModal">
                <div className={styles.attachmentsListContainer}>
                    <div className={styles.reviewQuoteAttachmentsHeader}>
                        <div
                            className={styles.columnHeader}
                            style={{
                                marginLeft: 10,
                            }}
                        >
                            Attached Documents ({attachments.length})
                        </div>
                        <div className={styles.columnHeader}>Uploaded</div>
                        <div className={'centered'}>
                            <div
                                className={'a-i-close'}
                                onClick={close}
                                style={{ maxHeight: 15 }}
                            />
                        </div>
                    </div>
                    <Scrollbars
                        className={'scroll-bar'}
                        renderTrackHorizontal={() => <div />}
                        autoHeight
                        autoHeightMin={300}
                        autoHeightMax={300}
                        height={315}
                    >
                        {attachments.length > 0 ? (
                            <div className={styles.attachmentsListContainer}>
                                {attachments.map((row) => (
                                    <div className={styles.reviewQuoteAttachmentsRow}>
                                        <div style={{ textAlign: 'center', marginLeft: 10 }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                }}
                                            >
                                                <div
                                                    className={styles.attachmentLinks}
                                                    onClick={() => {
                                                        window.location.href =
                                                            getAttachmentDownloadURL(row)
                                                    }}
                                                >
                                                    {row.FriendlyFilename}
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            {row.UploadedTimestamp
                                                ? new Date(
                                                    row.UploadedTimestamp
                                                ).toLocaleDateString() +
                                                  ' ' +
                                                  new Date(
                                                      row.UploadedTimestamp
                                                  ).toLocaleTimeString([], { timeStyle: 'short' })
                                                : ''}
                                        </div>
                                        <div></div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className={'centered'} style={{ height: 315 }}>
                                <div>
                                    <div className={'centered'}>
                                        <span
                                            className={'k-icon k-i-file-txt k-i-txt'}
                                            style={{
                                                fontSize: '3em',
                                                color: 'var(--fadedText)',
                                            }}
                                        />
                                    </div>
                                    <div
                                        className={'centered'}
                                        style={{
                                            color: 'var(--fadedText)',
                                            fontStyle: 'italic',
                                            marginTop: 10,
                                        }}
                                    >
                                        No Files Available
                                    </div>
                                </div>
                            </div>
                        )}
                    </Scrollbars>
                </div>
            </div>
        )
    } else {
        return (
            <div className={styles.dropZone} onDrop={onDrop} data-testid="attachmentsDropZone">
                <div className={styles.attachmentsModal} data-testid="attachmentsModal">
                    <div className={styles.attachmentsListContainer}>
                        <div className={styles.attachmentsHeader}>
                            <div
                                className={styles.columnHeader}
                                style={{
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <div>Include</div>
                                <div>with Email</div>
                            </div>
                            <div
                                className={styles.columnHeader}
                                style={{ justifyContent: 'center' }}
                            >
                                Internal
                            </div>
                            <div
                                className={styles.columnHeader}
                                style={{ justifyContent: 'center' }}
                            >
                                External
                            </div>
                            <div className={styles.columnHeader}>File Name</div>
                            <div className={styles.columnHeader}>Uploaded</div>
                            <div></div>
                        </div>
                        <Scrollbars
                            className={'scroll-bar'}
                            renderTrackHorizontal={() => <div />}
                            autoHeight
                            autoHeightMin={300}
                            autoHeightMax={300}
                            height={315}
                        >
                            {attachments.length > 0 ? (
                                <div className={styles.attachmentsListContainer}>
                                    {attachments.map((row) => (
                                        <div className={styles.attachmentsRow}>
                                            <div style={{ textAlign: 'center' }}>
                                                <Checkbox
                                                    checked={row.IncludeWithOrder}
                                                    style={
                                                        row.IncludeWithOrder
                                                            ? { color: 'var(--linkblue)' }
                                                            : {}
                                                    }
                                                    onChange={(
                                                        event: ChangeEvent<HTMLInputElement>
                                                    ) => {
                                                        dispatch(
                                                            updateIncludeInEmail({
                                                                fileId: row.FileId,
                                                                includeWithOrder:
                                                                    event.target.checked,
                                                            })
                                                        )
                                                    }}
                                                    data-testid="attachmentIncludeWithEmailCheckbox"
                                                />
                                            </div>
                                            <div style={{ textAlign: 'center' }}>
                                                <StyledRadio
                                                    checked={row.Internal}
                                                    onChange={(checked: boolean) => {
                                                        if (!row.Internal) {
                                                            updateIsInternal(row.FileId, checked)
                                                        }
                                                    }}
                                                    testid="attachmentInternalRadioButton"
                                                />
                                            </div>
                                            <div style={{ textAlign: 'center' }}>
                                                <StyledRadio
                                                    checked={!row.Internal}
                                                    onChange={(checked: boolean) => {
                                                        if (row.Internal) {
                                                            updateIsInternal(row.FileId, !checked)
                                                        }
                                                    }}
                                                    testid="attachmentExternalRadioButton"
                                                />
                                            </div>
                                            {editingRowId === row.FileId ? (
                                                <div
                                                    style={{
                                                        display: 'grid',
                                                        gridTemplateColumns: 'auto 40px 40px',
                                                        gap: 10,
                                                        height: 10,
                                                    }}
                                                >
                                                    <FastQuoteInput
                                                        value={tempName}
                                                        inputStyle={{ padding: '4px 5px 2px 4px' }}
                                                        onChange={(value: string) => {
                                                            setTempName(value)
                                                        }}
                                                        maxLength={100}
                                                        inputRef={(ref: any) => {
                                                            if (
                                                                ref &&
                                                                document.activeElement !== ref
                                                            ) {
                                                                let cValue: string = ref.value
                                                                let extensionStart =
                                                                    cValue.indexOf('.')
                                                                extensionStart && ref.focus()
                                                                extensionStart &&
                                                                    ref.setSelectionRange(
                                                                        0,
                                                                        extensionStart
                                                                    )
                                                            }
                                                        }}
                                                        testid="attachmentFieldName"
                                                    />
                                                    <div
                                                        className={styles.attachmentLinks}
                                                        style={{
                                                            marginRight: 5,
                                                            textDecoration: 'unset',
                                                        }}
                                                        onClick={() => setEditingRowId(false)}
                                                        data-testid="attachmentFieldUndo"
                                                    >
                                                        {' '}
                                                        Undo{' '}
                                                    </div>
                                                    <div
                                                        className={styles.attachmentLinks}
                                                        style={{
                                                            marginRight: 5,
                                                            textDecoration: 'unset',
                                                        }}
                                                        onClick={() => {
                                                            dispatch(
                                                                updateFileName({
                                                                    fileId: row.FileId,
                                                                    fileName: tempName,
                                                                })
                                                            )
                                                            setEditingRowId(false)
                                                        }}
                                                        data-testid="attachmentFieldSave"
                                                    >
                                                        {' '}
                                                        Save{' '}
                                                    </div>
                                                </div>
                                            ) : (
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        overflowWrap: 'anywhere',
                                                    }}
                                                >
                                                    <div
                                                        className={styles.attachmentLinks}
                                                        onClick={() => {
                                                            window.location.href =
                                                                getAttachmentDownloadURL(row)
                                                        }}
                                                    >
                                                        {row.FriendlyFilename}
                                                    </div>
                                                </div>
                                            )}
                                            <div>
                                                {row.UploadedTimestamp
                                                    ? new Date(
                                                        row.UploadedTimestamp
                                                    ).toLocaleDateString()
                                                    : ''}
                                            </div>
                                            <div
                                                className={styles.attachmentLinks}
                                                style={{
                                                    textAlign: 'center',
                                                    verticalAlign: 'center',
                                                    textDecoration: 'unset',
                                                }}
                                                onClick={() => {
                                                    setEditingRowId(row.FileId)
                                                    setTempName(row.FriendlyFilename)
                                                }}
                                                data-testid="attachmentFieldEdit"
                                            >
                                                <SvgIcon icon={EditPencil} height={15} />
                                            </div>
                                            <div className={'centered'}>
                                                <div
                                                    className={'a-i-close'}
                                                    data-testid="attachmentDeleteFile"
                                                    onClick={() => onDelete(row.FileId)}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className={'centered'} style={{ height: 315 }}>
                                    <div>
                                        <div className={'centered'}>
                                            <span
                                                className={'k-icon k-i-file-txt k-i-txt'}
                                                style={{
                                                    fontSize: '3em',
                                                    color: 'var(--fadedText)',
                                                }}
                                            />
                                        </div>
                                        <div
                                            className={'centered'}
                                            style={{
                                                color: 'var(--fadedText)',
                                                fontStyle: 'italic',
                                                marginTop: 10,
                                            }}
                                        >
                                            Add Files to attach or drag and drop files here
                                        </div>
                                        <div
                                            className={'centered'}
                                            style={{
                                                color: 'var(--fadedText)',
                                                fontStyle: 'italic',
                                                marginTop: 10,
                                            }}
                                        >
                                            (Maximum file size: 20mb)
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Scrollbars>
                    </div>
                    <div className={styles.attachmentsButtons}>
                        <span
                            className={'centered'}
                            style={{
                                display: 'inline-flex',
                                color: 'var(--fadedText)',
                                marginBottom: 5,
                                fontSize: 14,
                            }}
                        >
                            You may also drag and drop files into this window
                        </span>
                        <div
                            className={'a-cancel-button'}
                            style={{ fontWeight: 400, width: 260 }}
                            onClick={onAttachmentClick}
                        >
                            <span className={'k-icon k-i-clip-45'}></span>
                            &nbsp;Select documents to attach...
                            <input
                                type="file"
                                id="file"
                                ref={inputFile}
                                style={{ display: 'none' }}
                                onChange={onChangeFile}
                                multiple
                            />
                        </div>
                        <div
                            style={{
                                height: 31,
                                fontWeight: 400,
                                // alignSelf: 'center',
                                // textAlign: 'center',
                            }}
                        >
                            <AWCButton
                                type={BUTTON_TYPES.PRIMARY}
                                onClick={close}
                                data-testid="attachDocumentsDoneButton"
                            >
                                Done
                            </AWCButton>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
